import { Theme, createStyles, makeStyles } from '@material-ui/core';
import { title } from 'process';
import * as React from 'react';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
title: {
    color: "#890608",
    fontSize: 32,
    marginBottom: 15,
    alignItems: "left"
},
})
);

export const Sitemap: React.FC = () => {

const listingUIDs = [
    { uid: "64537af5d63a1a0399119ddf",name: "RPB Chambre 5 + Bord de mer" },
    { uid: "6544f5c9bdcd1865deb2f41c",name: "HE Appart 402 + Gym" },
    { uid: "6544e546bdcd1865deb250cd",name: "HE Studio 401 + Gym" },
    { uid: "641c2b435cb8fd8bd6616041",name: "RAP Appart 101 + Piscine" },
    { uid: "65451181bdcd1865deb36bb4",name: "HE Studio 402 + Gym" },
    { uid: "6544c5a4bdcd1865deb0b661",name: "HE Appart 401 + Gym" },
    { uid: "6422d537544ca95fd43ff52d",name: "RAP Appart 201 + Piscine" },
    { uid: "65eaeddc8f4c9eab62cb178c",name: "FAB Studio 5B" },
    { uid: "65ec3847d0d5d0a1f598d708",name: "FAB Studio " },
    { uid: "6642008954290ac754d714df",name: "KDN Appartement Deluxe" },
    { uid: "62e8fd3fbe7dc2084bb24486",name: "Appartement 112" },
    { uid: "663bcd050fc2a895bed53bb5",name: "NR Appart 7 + Piscine & Bord mer" },
    { uid: "662a52d2a05d489e185f192d",name: "RSN Appart       [Video]" },
    { uid: "662a51d1a05d489e185e2d96",name: "RPT Appart 3 - Chambres      [Video]" },
    { uid: "64df406f019fddc61085c26a",name: "RSN Studio" },
    { uid: "63977e5ba6a1c7d934121fae",name: "Gîtes de Kribi | Chalet Wood Nature" },
    { uid: "661d3a3ddc3d5be4cf2c587d",name: "RENAULT Clio | Automatique | Essence | Avec Chauffeur " },
    { uid: "66016adcaa218283e375d5c9",name: "WDR Studio 303" },
    { uid: "66015188aa218283e374baa6",name: "WDR Studio 103" },
    { uid: "6602ae01aa218283e3811488",name: "Villa W Téranga + Piscine" },
    { uid: "6517f215bdcd1865de10b9ac",name: "MP Studio RDC + piscine" },
    { uid: "65eb38a8d0d5d0a1f593df04",name: "NR Chambre + Piscine & Bord de mer" },
    { uid: "65eb4171d0d5d0a1f5940cab",name: "NR Chambre + Piscine & Bord de mer" },
    { uid: "6405b265ff7f832ea5a8ff6c",name: "RLC Appart 2" },
    { uid: "640740a462bfa03a8dafbbf1",name: "RLC Studio 6" },
    { uid: "6407431162bfa03a8dafe9f5",name: "RLC Studio 7" },
    { uid: "64072ec362bfa03a8dada1b1",name: "RLC Studio 1" },
    { uid: "6407361362bfa03a8dae5912",name: "RLC Studio 2" },
    { uid: "64073a9b62bfa03a8daea6e3",name: "RLC Studio 3" },
    { uid: "64073cf062bfa03a8daf19c8",name: "RLC Studio 4" },
    { uid: "64073ffc62bfa03a8dafba79",name: "RLC Studio 5" },
    { uid: "6407430862bfa03a8dafe9d1",name: "RLC Studio 8" },
    { uid: "6407467262bfa03a8daff4af",name: "RLC Studio 9" },
    { uid: "6405b44eff7f832ea5a94825",name: "RLC Appart 3" },
    { uid: "6405b6d2ff7f832ea5a96471",name: "RLC Appart 4" },
    { uid: "6405b7faff7f832ea5a968d2",name: "RLC Appart 5" },
    { uid: "6405b912ff7f832ea5a98310",name: "RLC Appart 6" },
    { uid: "6405ba5dedbbc7f46257087f",name: "RLC Appart 7" },
    { uid: "6405bb5dedbbc7f462570e7c",name: "RLC Appart 8" },
    { uid: "6405bc6cedbbc7f462571861",name: "RLC Appart 9" },
    { uid: "65e9843b8f4c9eab62c1af43",name: "RSN Appart + Piscine" },
    { uid: "65e98a0b8f4c9eab62c20e7c",name: "RSN Studio + Piscine" },
    { uid: "65ccbfa56889d0ff5bfffd75",name: "RCR Chambre 2       [Video]" },
    { uid: "65e5b5df8f4c9eab62a0d8da",name: "RSN Appart " },
    { uid: "65e1f4f721045ec38b6c78e7",name: "RPT Appart 4A     [Video]" },
    { uid: "65e1fe8d21045ec38b6d3116",name: "RPT Appart 5A                   [Video]" },
    { uid: "65e204cc21045ec38b6d5d1e",name: "RPT Studio 5B                             [Video]" },
    { uid: "65e5a4678f4c9eab62a0c4a9",name: "NR Appart 10 + Piscine  & Bord de mer" },
    { uid: "65e596158f4c9eab62a07ad2",name: "NR Appart 9 +Piscine & Bord de mer" },
    { uid: "65e58a5b95c6238ab6206f2a",name: "NR Appart 8 + Piscine & Bord de mer" },
    { uid: "65e3196921045ec38b7aa3ce",name: "NR Appart 1 + Piscine & Bord mer" },
    { uid: "65e321aa95c6238ab60f95a7",name: "NR Appart 2 + Piscine & Bord de mer" },
    { uid: "65719bd3e6e603cc7878b090",name: "RO Studio 301" },
    { uid: "65d5c35f6889d0ff5b3a5c3c",name: "MJ Suite Présidentielle 2 + Cuisine     [Video]" },
    { uid: "65d6074d6889d0ff5b3bddaf",name: "MJ Studio 1              [Video]" },
    { uid: "65d607b16889d0ff5b3bde0d",name: "MJ Studio 2" },
    { uid: "65d608626889d0ff5b3bde71",name: "MJ Standard Room 2" },
    { uid: "65d082226889d0ff5b192aaf",name: "HR Studio 102       [Video]" },
    { uid: "65d091cf6889d0ff5b197e37",name: "HR Studio 103          [Video]" },
    { uid: "65d096086889d0ff5b198185",name: "HR Appart 200     [Video]" },
    { uid: "65d098c56889d0ff5b19ab85",name: "RL Appart 2   [Video]" },
    { uid: "65c74ac3992259a34771f6cc",name: "RS Appart 503" },
    { uid: "65cb9b6065f553ea5d6bb760",name: "RF Studio 203   [Video]" },
    { uid: "65c75e1d992259a347728011",name: "RS Appart 403" },
    { uid: "65c7557e992259a347727916",name: "RS Appart 402" },
    { uid: "65a55f88d6cf02b7d6430a9e",name: "RV Appart D2                 [Video]" },
    { uid: "65a556b3d6cf02b7d642a455",name: "RV Appart C2                    [Video]" },
    { uid: "65a553aed6cf02b7d642820f",name: "RV Chambre 3                     [Video]" },
    { uid: "65a5421dd6cf02b7d641ee5c",name: "RV Appart C3              [Video]" },
    { uid: "65c4db2e02e13b365ee5a326",name: "RF Appart 302   [Video]" },
    { uid: "65afe55380a6d0240c401fd7",name: "SC Studio Polkadot + Gym    [Video]" },
    { uid: "65c22cc3df17c1a547c97872",name: "RB Studio SS      [Video]" },
    { uid: "65c228aadf17c1a547c97321",name: "RB Appart SS1     [Video]" },
    { uid: "65c11b92df17c1a547c1dbd6",name: "RB Studio 1B     [Video]" },
    { uid: "65c10812df17c1a547c17881",name: "SC Studio Waves + Gym" },
    { uid: "633c2538e551c7a3e6cd1927",name: "RB Appart 1A       [Video] " },
    { uid: "633ec1f5d8bef57b1018354c",name: "SMB Studio IOTA + Gym" },
    { uid: "64804a5c2ddf35eba3a27342",name: "RSN Studio" },
    { uid: "65b7bc70df17c1a5479aad5b",name: "RI Appart D       [Video]" },
    { uid: "65b4c93680a6d0240c558d0a",name: "RI Appart 401 + Piscine   [Video]" },
    { uid: "65b4d01580a6d0240c55de12",name: "RI Appart 402 + Piscine   [Video]" },
    { uid: "65b4d83180a6d0240c560b12",name: "RI Appart 403 + Piscine   [Video]" },
    { uid: "65b4e5be80a6d0240c564154",name: "RI Appart 303 + Piscine   [Video]" },
    { uid: "63f8d4d4446ca3579880ee72",name: "RI Appart A       [Video]" },
    { uid: "659fcfa5d6cf02b7d62b1143",name: "RVH Appart Bonadouma  [Video]" },
    { uid: "657ad3a603a6a9536aae0232",name: "HLF Chambre Junior + Piscine     [Video]" },
    { uid: "65806bf7f15cc09830ad2017",name: "RNP Studio Nyong" },
    { uid: "658073adf15cc09830ad9090",name: "RNP Studio Wouri" },
    { uid: "657adced03a6a9536aaf3ff1",name: "HLF Suite + Piscine  [Video]" },
    { uid: "657c57cdd0ea7b62ccb5e809",name: "R A&J Homes Appart 202       [Video]" },
    { uid: "658411b3f15cc09830c306ca",name: "RM Appart 1     [Video]" },
    { uid: "65707db10c56efcb7cbbcb46",name: "VC Studio 11   [Video]" },
    { uid: "657ae74603a6a9536ab02db7",name: "HLF Chambre Standard + Piscine  [Video]" },
    { uid: "656723acd283c17b595a3ddc",name: "RSC Chambre 10 + Cuisine" },
    { uid: "6571e4d5e6e603cc787b5101",name: "RO Studio 102" },
    { uid: "65674f32d283c17b595bbe79",name: "RSC Studio 1       [Video]" },
    { uid: "6571df97e6e603cc787b4ccc",name: "RO Chambre 104" },
    { uid: "657b16d2d0ea7b62ccaa8975",name: "OH Chambre Standard" },
    { uid: "657b1227d0ea7b62ccaa82b4",name: "OH Chambre Confort" },
    { uid: "657b0ab303a6a9536ab43a88",name: "OH Chambre Confort plus [Vidéo]" },
    { uid: "656ddf3ae94edc87eede741b",name: "RLM Studio 5 [Video]" },
    { uid: "656dd71ce94edc87eede2539",name: "RLM Studio 2 [Video]" },
    { uid: "656dc3cfe94edc87eedc6f5b",name: "RLM Appart 3 [Video]" },
    { uid: "6572e7f4e6e603cc78826471",name: "TFR Appart Kigali + Gym [Video]" },
    { uid: "65706c86df4921cae62fb174",name: "VC Appart 43 Junior Suite       [Video]" },
    { uid: "65705099e3d1f0c128e5b168",name: "VC Appart 41 Senior Suite [Vidéo]" },
    { uid: "6516d2debdcd1865de0c7454",name: "BHGH Appart Nicosie   [Video]" },
    { uid: "65689758e94edc87eeb68eee",name: "RA Studio 105       [Video]" },
    { uid: "64818f25565e9eb906acde25",name: "RTDD Studio 1  [Video]" },
    { uid: "65632a9339684f2fab2531f7",name: "RCL Appart     [Video]" },
    { uid: "65688fdbd283c17b5963399a",name: "RA Studio 401       [Video]" },
    { uid: "65675745d283c17b595c433d",name: "RA Studio 403" },
    { uid: "656748f6d283c17b595b7ef3",name: "RSC Appart 8       [Video]" },
    { uid: "6566f27f39684f2fab34a930",name: "RTDD Studio 4       [Video]" },
    { uid: "655b6d84bdcd1865de1420bf",name: "RL Appart 2 " },
    { uid: "6560b7ba39684f2fab19ad83",name: "RTS Chambre Londres 201 + Cuisine " },
    { uid: "653f72ecbdcd1865de9d89f1",name: "HS Studio 7" },
    { uid: "653fcb84bdcd1865de9f0c35",name: "HS Studio" },
    { uid: "653fb8acbdcd1865de9ed3cf",name: "HS Appart 1" },
    { uid: "6555fc47bdcd1865de0029f3",name: "RVH Studio" },
    { uid: "642c06becebc50c1793287c8",name: "RVH Appart 1" },
    { uid: "640b1325baf2b81f4314df26",name: "RF Appart  202       [Video]" },
    { uid: "6517fa95bdcd1865de1104af",name: "MP Studio étage + Piscine" },
    { uid: "6518008fbdcd1865de115a52",name: "Villa Prestige + Piscine" },
    { uid: "643f1392936b5b09f49f3a81",name: "RSN Appart" },
    { uid: "64f8a2893bf350ba7de72191",name: "DGH Studio" },
    { uid: "64f84f473bf350ba7de5667d",name: "RTAA Appart A4" },
    { uid: "64f0c1c23bf350ba7dbfd85e",name: "JH Chambre Standard" },
    { uid: "64f1bc663bf350ba7dc5dba9",name: "JH Suite VIP" },
    { uid: "64eda51f50255f98147a1348",name: "RCP Appart 201    [Video]" },
    { uid: "64e727a650255f98145d9a1d",name: "AH Appart 1" },
    { uid: "642c0008cebc50c17930d51d",name: "SH Appart 2       [Video]" },
    { uid: "641c630b178bbe955be72906",name: "RAP Studio 503 + Piscine" },
    { uid: "64f0a22650255f98148e6afa",name: "RJJ Appart 105" },
    { uid: "64995360c1c337d91354cd24",name: "RLCDV Appart Jaune" },
    { uid: "6499681ec1c337d91354faba",name: "RLCDV Appart Bleu" },
    { uid: "6412ee23bcecfd1818f495df",name: "RT Appart T1 Paris      [Video]" },
    { uid: "636e455e46119dcb09c41223",name: "RT Appart T2 Moscou       [Video]" },
    { uid: "6447e236528a139022099024",name: "HT Chambre Standard vue sur mer + Piscine & Bord de mer + Gym" },
    { uid: "6448dc62528a1390220cf232",name: "HT Chambre Standard vue sur jardin 2 lits + Piscine & Bord de mer + Gym" },
    { uid: "645b9084510ab250d144e42a",name: "HT Chambre Standard vue sur jardin 1 lit + Piscine & Bord de mer + Gym" },
    { uid: "64105b8efca43acaa5fb7151",name: "RR Studio RDC + Bord de mer" },
    { uid: "641060dbfca43acaa5fbd967",name: "RR Studio Etage + Bord de mer" },
    { uid: "641047cbfca43acaa5f888f9",name: "RR Duplex 3 Chambres + Bord de mer" },
    { uid: "641065ec770767cfad8977d0",name: "RR Appart RDC + Bord de mer" },
    { uid: "641069fd770767cfad89dfdf",name: "RR Appart Etage + Bord de mer" },
    { uid: "646b45c9f6e40ad1d02b669e",name: "RSC Studio Verge" },
    { uid: "646b3edb27445babdbe55481",name: "RSC Studio Nem" },
    { uid: "64552ffe5dbdf139acb24feb",name: "RSC Studio Ethereum" },
    { uid: "6499b3bfc1c337d91358260f",name: "RS Studio 601" },
    { uid: "6499c11cc1c337d913582bf1",name: "RS Appart 602" },
    { uid: "6499a639c1c337d913580bfe",name: "RS Appart 502" },
    { uid: "649990d5c1c337d913573169",name: "RS Appart 302" },
    { uid: "64999b80c1c337d913578886",name: "RS Appart 202" },
    { uid: "63e61d5df586b49c5b45198c",name: "Maison Caze - Pieds Dans leau" },
    { uid: "64d3a40a4907889c24123d97",name: "AH Studio " },
    { uid: "64d64112019fddc610482592",name: "RSN Appart L 17 + Piscine" },
    { uid: "64b51474bde052c3094efe04",name: "RFI Appart + Bord de mer" },
    { uid: "642d36be501105e4d084d624",name: "RF Appart 501" },
    { uid: "63e25bf576069bde9fd3771d",name: "RNP Appart 01" },
    { uid: "64d7558f019fddc6104f7a42",name: "RLGH Studio" },
    { uid: "64e08e98019fddc61090f7c3",name: "DGH Appart 101" },
    { uid: "646f6c6ce176054b09c1af2c",name: "RS Appart 102" },
    { uid: "6406f2c83956c205cea26858",name: "SGH chambre 6 + Piscine & Gym" },
    { uid: "640235abff7f832ea588d957",name: "SGH chambre 2 + Piscine & Gym" },
    { uid: "64020c4bff7f832ea583dfae",name: "SGH Chambre 1 + Piscine & Gym & Jacuzzi" },
    { uid: "64031527ff7f832ea594c1f1",name: "SGH chambre 4 + Piscine & Gym" },
    { uid: "640339f0ff7f832ea59618f0",name: "SGH chambre 5 + piscine & gyms" },
    { uid: "645e1dd6a8aa448be7891c13",name: "RCR Studio 2              [Video]" },
    { uid: "645e3650b91c6be2f3ff2a84",name: "RCR Chambre 1                  [Video]" },
    { uid: "645e26a0a8aa448be7895e91",name: "RCR Appart " },
    { uid: "64d2723c8bf457cad926b8f1",name: "VDF Chambre Opera + Piscine" },
    { uid: "64d26bb18bf457cad926598f",name: "VDF Chambre  Champs-Elysées + Piscine" },
    { uid: "64d27b618bf457cad926e5ed",name: "VDF Chambre Saint Germain + Piscine" },
    { uid: "64d35a9c4907889c240db4bb",name: "VDF Chambre Faubourg Saint-Honore + Piscine" },
    { uid: "6409be3962bfa03a8dd44c7d",name: "Villa Poussada 3-chambres" },
    { uid: "64a53243fb047ab8682482c1",name: "RAD Appart 2 Chambres" },
    { uid: "64a2d6d2073018a9eab993d2",name: "RAD Appart 3 Chambres" },
    { uid: "64ad4ba1e332600cb4052e19",name: "RLWH Studio 1 Luna" },
    { uid: "64ad5510e332600cb405aa11",name: "RLWH Studio 2 Luna" },
    { uid: "64a95188e332600cb4eaa797",name: "RV Villa 3 Chambres" },
    { uid: "64a95d07e332600cb4ec2d7f",name: "RV Studio " },
    { uid: "64a958b4e332600cb4ebb365",name: "RV Villa 2 Chambres" },
    { uid: "64c0e84539e99e4dcb7fd606",name: "RLC Appart 3 Chambres + Piscine & Gym" },
    { uid: "64be5f69bde052c30948e4ca",name: "RLC Studio " },
    { uid: "64be7706bde052c3094cd459",name: "RLC Appart 2 Chambres" },
    { uid: "64be8115bde052c3094e1660",name: "RLC Appart 3 chambres" },
    { uid: "64be8e37bde052c309504c91",name: "RLC Studio" },
    { uid: "64be9a98bde052c309525176",name: "Res Le Carat Appart " },
    { uid: "64bea04dbde052c309537542",name: "Residence Le Carat - Studio + Piscine & Gym" },
    { uid: "64ae6bfda92f4e52020abdce",name: "RM Villa 3 Chambres + Piscine" },
    { uid: "64ae96e3a92f4e52020c76a3",name: "RM Villa 2 Chambres + Piscine" },
    { uid: "6454eefd5dbdf139acadecfc",name: "RLWH Appart Lobe" },
    { uid: "64a7d0eee332600cb4e483e5",name: "HHL Chambre Classique" },
    { uid: "64a950f4e332600cb4ea9307",name: "HHL Chambre Standard" },
    { uid: "64a922e5e332600cb4e8b3cc",name: "HHL Chambre VIP Supérieur" },
    { uid: "64b5231fbde052c309510fb4",name: "RFI Chambre + Bord de mer" },
    { uid: "64b506afa9ad8cb2381d001a",name: "RFI Chambre+ Cuisine & Bord de mer" },
    { uid: "64ac1ac2e332600cb4fbf53b",name: "RSN Appart 1C + Piscine " },
    { uid: "64ad1505e332600cb4029ec0",name: "RSN Appart 4C + Piscine" },
    { uid: "64b02a24a92f4e52021eba93",name: "DMR Appart Falla + Bord de mer" },
    { uid: "64ac21e9e332600cb4fc20f9",name: "RSN Appart 2C+ Piscine" },
    { uid: "64b00ce1a92f4e52021def22",name: "DMR Appart Ebene + Bord de mer" },
    { uid: "64b1240c6b172d75f5fd92bd",name: "RSN Appart 2A + Piscine" },
    { uid: "64b033daa92f4e52021f6658",name: "DMR Suite Beach Park + Cuisine & Bord de mer " },
    { uid: "64b178966b172d75f5010257",name: "RSN Appart 3C + Piscine" },
    { uid: "64abc8dfe332600cb4f796c5",name: "RM Villa + Piscine                             [Video]" },
    { uid: "64a2fbda073018a9eabb51d4",name: "RGA Villa + Piscine" },
    { uid: "64a2eacf073018a9eab9f016",name: "RNA Studio" },
    { uid: "64a2e4d9073018a9eab9d7f9",name: "RNA Chambre blanche" },
    { uid: "64a2db62073018a9eab9d6b0",name: "RNA Appart rouge" },
    { uid: "64ad877ce332600cb4075696",name: "RM Appart BR" },
    { uid: "64ad7bebe332600cb4073c66",name: "RM Appart AD" },
    { uid: "64aeac35a92f4e52020d761c",name: "RM Studio Loulou" },
    { uid: "64aea0e2a92f4e52020d496e",name: "RM Appart Briana" },
    { uid: "64aea7b4a92f4e52020d734c",name: "RM Studio Feré" },
    { uid: "64636fc3b91c6be2f33bdb75",name: "SA 2 bedrooms ground floor apart" },
    { uid: "64031935ff7f832ea594fd3b",name: "RLY Studio 204" },
    { uid: "64a55e5f98ce9bf8cd9292e1",name: "RM Appart 4 + Piscine" },
    { uid: "64a3e52bfb047ab8681c654c",name: "RGA Appart + Piscine" },
    { uid: "64a3f93ffb047ab8681d27d4",name: "RNA Appart Orange" },
    { uid: "64a3cfd1073018a9eabdf759",name: "RGA Appart + Piscine" },
    { uid: "64a2c1fc073018a9eab963dd",name: "RLM Appart 2 + Piscine" },
    { uid: "64a2b949073018a9eab94fc3",name: "RLM Appart 6 + Piscine" },
    { uid: "64a2a94fbbf0a1821cc7e701",name: "RLM Appart 5 + Piscine" },
    { uid: "64a3f246fb047ab8681c8192",name: "RNA appart bleu" },
    { uid: "64a54bface4cf3f09a6ad1f2",name: "RM Appart 2 + Piscine" },
    { uid: "648d9189e7c51b699c1a8281",name: "RM Studio 201" },
    { uid: "64904380e85b257ab2926147",name: "RM Studio 303" },
    { uid: "649593a2c1c337d913463abf",name: "SH Studio 202 Suite Royale + Piscine  [Video]" },
    { uid: "64958ebac1c337d913461765",name: "SH Chambre 101 Standard + Piscine [Video]" },
    { uid: "64958705c1c337d913458f84",name: "SH Studio 201 Suite Senior + Piscine [Video]" },
    { uid: "64957e053f505b947dce9d5c",name: "SH Studio 103 Suite junior + Piscine [Video]" },
    { uid: "6495798f3f505b947dce9954",name: "SH Studio 102 Suite Royal + Piscine [Video]" },
    { uid: "649bffbcef2c661feedc5e38",name: "RL Chambre Rouge" },
    { uid: "649bfbf0ef2c661feedc3ace",name: "RL Chambre Bleue" },
    { uid: "649bf775ef2c661feedc388f",name: "RL Chambre Marron" },
    { uid: "6482e7c6565e9eb906b5131c",name: "RS Appart 201" },
    { uid: "64906a95e85b257ab293512b",name: "RM Appart 103" },
    { uid: "648d82f6fd818721706c4267",name: "RM Appart 203" },
    { uid: "648d97c6e7c51b699c1b0186",name: "RM Appart 301" },
    { uid: "6492fc6e3f505b947dbfca47",name: "RM Appart 102" },
    { uid: "649061c9e85b257ab292c255",name: "RM Appart 402" },
    { uid: "6490525fe85b257ab2926688",name: "RM Appart 4O1" },
    { uid: "64903cd7e85b257ab291d94f",name: "RM Appart 302" },
    { uid: "649064d0e85b257ab2930af6",name: "RM Appart 101" },
    { uid: "6491c2df3f505b947db5f8da",name: "RM Chambre R1 + Cuisine" },
    { uid: "648c6821fd81872170662501",name: "SBH Chambre Twin" },
    { uid: "648c4a0cfd81872170642b99",name: "SBH Suite Senior" },
    { uid: "648c4581fd8187217063e712",name: "SBH Suite Junior" },
    { uid: "648c38b8fd8187217062c284",name: "SBH Chambre Grand Standard" },
    { uid: "648c1cc31adfc120bff071a8",name: "SBH Chambre Standard moyen" },
    { uid: "648c14e01adfc120bff01b2f",name: "SBH Chambre Mini standard" },
    { uid: "648c93ddfd81872170689c74",name: "RMR Chambre + Cuisine" },
    { uid: "648322c037324c1a81c2740a",name: "RS Chambre 402" },
    { uid: "648328fd37324c1a81c2a8d0",name: "RS Chambre 302" },
    { uid: "6482f379565e9eb906b51a88",name: "RS Chambre 202" },
    { uid: "64830049565e9eb906b5b33c",name: "RS Appart 401" },
    { uid: "6482fcb2565e9eb906b53e2d",name: "RS Appart 103" },
    { uid: "645e0930a8aa448be78877bb",name: "RSN Appartement Haut Standing" },
    { uid: "64414453936b5b09f4b1b2b7",name: "AMA Appart Emeraude" },
    { uid: "6471cf4eebac2cbe06c2c850",name: "RP Appart Serenity home" },
    { uid: "648088222ddf35eba3a2f0db",name: "RSN Studio " },
    { uid: "645e1376a8aa448be788cda4",name: "RSN Studio" },
    { uid: "645df873a8aa448be787cbc4",name: "RSN Chambre Confortable" },
    { uid: "645e03f1a8aa448be7885f08",name: "RSN Chambre Haut Standing" },
    { uid: "635bcc5e588a4794adff84e6",name: "RTA Appart Libreville" },
    { uid: "635bcb58588a4794adff7761",name: "RTA Appart Dublin" },
    { uid: "6384de8ba6572e03de826fdc",name: "MB Studio 402 " },
    { uid: "6385e2ff046f342b0cccd457",name: "MB Appart 203 2-Chambres" },
    { uid: "63f8e263446ca357988254d8",name: "RI Appart C" },
    { uid: "63f9eb42a43c20c2b80405c8",name: "RN Chambre " },
    { uid: "64638e5927445babdbabae1c",name: "SA Studio étage " },
    { uid: "646f7569e176054b09c32140",name: "RCM Villa" },
    { uid: "6470be79ebac2cbe06bca715",name: "HMP Chambre mini salon" },
    { uid: "6470b47aebac2cbe06bc68fc",name: "HMP Chambre Ventilée" },
    { uid: "6474789bebac2cbe06cf1e29",name: "SA 2 bedrooms floor apartment" },
    { uid: "6475c34eebac2cbe06df5045",name: "RA Appart 502" },
    { uid: "6475dfa146226a904c5c6ece",name: "RA Studio 503" },
    { uid: "6475da8346226a904c5c6abc",name: "RA Studio 504" },
    { uid: "6479b96b2ddf35eba380b73f",name: "RN Chambre 3" },
    { uid: "6479a78c2ddf35eba37f9b2a",name: "RN Chambre 1" },
    { uid: "6479afb12ddf35eba380b239",name: "RN Chambre 2" },
    { uid: "645caa0ca8aa448be779aa0d",name: "RP Dortoir femmes" },
    { uid: "646dd205f6e40ad1d03c53d9",name: "VDK Chambre Lobe + Bord de mer" },
    { uid: "646ce440f6e40ad1d03a5047",name: "VDK Chambre Campo + Bord de mer" },
    { uid: "646ce6fff6e40ad1d03a51bf",name: "VDK Chambre  Mboamanga + Bord de mer" },
    { uid: "63cfbd5b8a6f6bd1b140ad52",name: "RFP Appart Bibiche     [Video]" },
    { uid: "6454e8fd5dbdf139acadb900",name: "DLG Studio 2 + Bord de mer & Piscine" },
    { uid: "6454d96f5dbdf139acad45e2",name: "DLG Appart 1 + Bord de mer & Piscine" },
    { uid: "643d45e7936b5b09f47f24db",name: "SA 3 bedrooms ground floor apart" },
    { uid: "645ca271510ab250d14cbafa",name: "RP Dortoir Homme" },
    { uid: "6461e681b91c6be2f31bc93e",name: "HB Chambre " },
    { uid: "6461f67cb91c6be2f31cc54c",name: "HB Studio" },
    { uid: "64637db227445babdbaac001",name: "SA ground floor studio" },
    { uid: "6464c9f827445babdbb88e41",name: "VDR Chambre 123" },
    { uid: "642bf968cebc50c1793069dc",name: "VDR Chambres 121" },
    { uid: "643e8dda936b5b09f495f6a7",name: "RA Appart 3" },
    { uid: "645bc6ad510ab250d146c6dc",name: "RG Appart Le bunker" },
    { uid: "645cd675a8aa448be77d864d",name: "HC Chambre Standard" },
    { uid: "645cdfeca8aa448be77e376d",name: "RG Studio RDC" },
    { uid: "64538282d63a1a0399121d8e",name: "RPB Chambre 7 + Bord de mer" },
    { uid: "645392e7c84a36103600d2ab",name: "RPB Studio 10 + Bord de mer" },
    { uid: "6454ba26c84a361036129db9",name: "RPB Appart 12 + Bord de mer" },
    { uid: "64537657d63a1a0399115171",name: "RPB  Chambre 4 + Bord de mer" },
    { uid: "645a31fcacac1fedc1020589",name: "RLY Chambre 212" },
    { uid: "645a0241acac1fedc1ffbd20",name: "RP Chambre C + Cuisine" },
    { uid: "6438093ee83d30252b311ab7",name: "HT Appart 238 + Bord de mer + Gym" },
    { uid: "6458ece0acac1fedc1f9f48e",name: "RM Appart 2" },
    { uid: "6458f931acac1fedc1fa4cdf",name: "RM Duplex 3 chambres" },
    { uid: "6458d16d89c75ceb3e3705d2",name: "RM Appart 1" },
    { uid: "645a2615acac1fedc1016984",name: "RLY Chambre 209" },
    { uid: "645a22aeacac1fedc101664c",name: "RLY Chambre 206" },
    { uid: "645a1fc2acac1fedc101626e",name: "RLY Chambre 203" },
    { uid: "645a2efcacac1fedc101ad0f",name: "RLY Chambre 210" },
    { uid: "6458c68b7df75c688d0b921e",name: "RHO Appart Tahiti + Piscine" },
    { uid: "645624025dbdf139acb461dd",name: "RHO Studio Cabo-verde + Piscine" },
    { uid: "64562b225dbdf139acb4af8f",name: "RHO Studio Capri + Piscine" },
    { uid: "645630597df75c688d021068",name: "RHO Studio Santorin + Piscine" },
    { uid: "645634877df75c688d024456",name: "RHO Appart Royan + Piscine" },
    { uid: "645618765dbdf139acb422b4",name: "RHO Studio Nosy-be + Piscine" },
    { uid: "6452447bd63a1a039902a159",name: "RLY Chambre 207" },
    { uid: "64524ba8d63a1a039902dc89",name: "RLY Chambre 205 " },
    { uid: "64524ef6d63a1a0399032db7",name: "RLY Chambre  208" },
    { uid: "6459f5faacac1fedc1ff785d",name: "RP Chambre B + Cuisine" },
    { uid: "645a071eacac1fedc1ffddfb",name: "RP Appart 1er gauche" },
    { uid: "645a113dacac1fedc1006197",name: "RP Chambre A + Cuisine" },
    { uid: "645a1420acac1fedc10101e8",name: "RP Appart étage 2" },
    { uid: "6454e8b05dbdf139acadb864",name: "RLWH Appart Grand Batanga" },
    { uid: "6453a92dc84a36103604c54d",name: "RPB Appart 11 + Bord de mer" },
    { uid: "6454c16dc84a361036136f17",name: "RPB Appart 13 + Bord de mer" },
    { uid: "6454ccf25dbdf139acabecfd",name: "RPB Appart 14 + Bord de mer" },
    { uid: "6453a6a1c84a36103604208b",name: "DRK Appart Mapoubi" },
    { uid: "6453aaf6c84a36103604db58",name: "RDK Appart Masse" },
    { uid: "645366fed63a1a03990fff24",name: "RPB Appart 1 + Bord de mer" },
    { uid: "64536fffd63a1a039910daaa",name: "RPB Chambre 2 + Bord de mer" },
    { uid: "6453730dd63a1a03991125d2",name: "RPB Chambre 3 + Bord de mer" },
    { uid: "64537ef1d63a1a039911d111",name: "RPB Chambre 6 + Bord de mer" },
    { uid: "64538665c84a361036ffde32",name: "RPB Chambre 8 + Bord de mer" },
    { uid: "64538c01c84a361036ffff78",name: "RPB Studio 9 + Bord de mer" },
    { uid: "64527642d63a1a0399073bb9",name: "RLRDLL Studio 5" },
    { uid: "64526c89d63a1a039905e5d8",name: "RLRDLL Chambre 4 + Cuisine" },
    { uid: "64527075d63a1a0399068387",name: "RLRDLL Studio 3" },
    { uid: "6452532dd63a1a039903c1fa",name: "RLRDLL Appart 1" },
    { uid: "64525cc7d63a1a0399048a0b",name: "RLRDLL Appart 2" },
    { uid: "645108c4d63a1a0399fa56a9",name: "VO Elena + Piscine" },
    { uid: "64511b30d63a1a0399fba700",name: "VO Tiana + Piscine" },
    { uid: "6450fa32d63a1a0399f97122",name: "VO Rose + Piscine" },
    { uid: "644cf273d63a1a0399ed1686",name: "RC Studio 1" },
    { uid: "644cebbbd63a1a0399ecf6fd",name: "RC Studio 2" },
    { uid: "644ba08bd63a1a0399e3067a",name: "RRO Appart 202" },
    { uid: "6447ce48528a1390220845ea",name: "RC Appart A3 + Bord de mer" },
    { uid: "6447d27b528a1390220865ea",name: "RC Appart A8 + Bord de mer" },
    { uid: "6446a721528a139022ffce2a",name: "RS Appart 5 " },
    { uid: "6446aa66528a139022ffebe0",name: "RS Suite Royal" },
    { uid: "64469fde528a139022ff89c0",name: "RS Appart 6" },
    { uid: "643d45c2936b5b09f47f24b5",name: "RB Appart 2 " },
    { uid: "643d49ea936b5b09f47f26c1",name: "RB Appart 3 [Pas de Cuisine]" },
    { uid: "643d4c67936b5b09f47f452e",name: "RB Studio 2 droite" },
    { uid: "64398072163df3aed1ae0360",name: "RF Appart Ngoa-Ekele + Piscine" },
    { uid: "643a5f40163df3aed1b21878",name: "RF Appart Biyem-Assi + Piscine" },
    { uid: "643a712a163df3aed1b23a68",name: "RF Appart Ongola + Piscine" },
    { uid: "643a786e163df3aed1b23e97",name: "RF Appart Nkolfoulou + Piscine" },
    { uid: "64382a7d163df3aed1a12263",name: "RC Studio A7 + Bord de mer " },
    { uid: "643830c9163df3aed1a15c1d",name: "RC Chambre A6 + Bord de mer" },
    { uid: "643835e2163df3aed1a29950",name: "RC Chambre A9 + Bord de mer" },
    { uid: "64390728163df3aed1a69696",name: "RC Appart A5 + Bord de mer" },
    { uid: "6437fbf0e83d30252b302618",name: "RRP Apart first floor" },
    { uid: "6438019ce83d30252b3046f5",name: "RRP Appart Ground floor" },
    { uid: "64381d11163df3aed1a03d1b",name: "HT - Duplex avec Plage Privée (Bord de Mer + Gym)" },
    { uid: "642e8ca0e83d30252bb87d6e",name: "RF Studio 103       [Video]" },
    { uid: "642e9701e83d30252bb9a853",name: "RF Studio 503" },
    { uid: "642d60c4e83d30252ba7c186",name: "RF Appart 702" },
    { uid: "642d4643501105e4d086599b",name: "RF Appart 502" },
    { uid: "642d53e5e83d30252ba5c91c",name: "RF Appart 701" },
    { uid: "642c0394cebc50c17931f3fe",name: "SH Appart 3 [Video]" },
    { uid: "642c05d6cebc50c1793254af",name: "SH Appart 4       [Video]" },
    { uid: "642c07d3cebc50c179329f66",name: "SH Chambre 5       [Video]" },
    { uid: "642bfa92cebc50c179306b83",name: "SH Appart 1" },
    { uid: "642c009bcebc50c17931275f",name: "Villa des Roses - Chambre 122" },
    { uid: "642aa228cebc50c1790e8702",name: "RKP Studio 4" },
    { uid: "642aa7c3cebc50c1790fa41c",name: "RKP Studio 6" },
    { uid: "642aad33cebc50c1791036ef",name: "RKP Appart 5" },
    { uid: "6427f6a3cebc50c179e7f190",name: "RA Appart 4 " },
    { uid: "64270e00cebc50c179de2034",name: "RKP Appart 3" },
    { uid: "642704e3cebc50c179dcdb07",name: "RA Appart 01" },
    { uid: "64271378cebc50c179de7b2f",name: "RA Appart 02" },
    { uid: "6426e602cebc50c179da4f9f",name: "RKP Studio 1" },
    { uid: "64270291cebc50c179dc96e9",name: "RKP Appart 2" },
    { uid: "6426c8bfcebc50c179d6eb06",name: "RR Apart Second Floor" },
    { uid: "6426c175cebc50c179d603bc",name: "Royal Residence Apart First Floor" },
    { uid: "6426bcd0cebc50c179d56656",name: "Belavie Saint David - Chambre Luxe + Piscine" },
    { uid: "6426c3becebc50c179d639d3",name: "HSD Chambre Standard + Piscine" },
    { uid: "6426cacecebc50c179d75197",name: "HSD Suite Senior + Piscine" },
    { uid: "6426e0e4cebc50c179d9b1c0",name: "HSD Suite Junior + Piscine" },
    { uid: "6426ecedcebc50c179db03d5",name: "HSD Chambre Mini Standard + Piscine" },
    { uid: "6426f1c2cebc50c179db6364",name: "HSD Suite royale + Piscine" },
    { uid: "6426a525cebc50c179d4f196",name: "HSD Appart + Piscine" },
    { uid: "64269e6dcebc50c179d42c56",name: "RR Studio Ground floor" },
    { uid: "64258260cebc50c179c0e79c",name: "RTS Studio 2" },
    { uid: "6423feb9d37a52c029155ab9",name: "MH Appart " },
    { uid: "64255db5cebc50c179bf4992",name: "RLC Studio L6 + Piscine" },
    { uid: "6425739ecebc50c179bfcb93",name: "RLC Studio L7 + Piscine" },
    { uid: "64257795cebc50c179bfea1c",name: "RLC Appart L1 + Piscine" },
    { uid: "6423f5d6857f0466d57716dc",name: "RTT Apart  " },
    { uid: "642403bad37a52c029159a4c",name: "RTT -  Studio " },
    { uid: "6422fb4d544ca95fd445140e",name: "TA Studio 7 + Piscine       [Video]" },
    { uid: "6422ffbc544ca95fd4458b58",name: "TA Appart 41 + Piscine" },
    { uid: "642301c1544ca95fd4459c00",name: "TA Studio 44 + Piscine" },
    { uid: "6422dec5544ca95fd4426023",name: "TA Studio 11 + Piscine" },
    { uid: "6422e407544ca95fd442f10f",name: "TA Studio 12 + Piscine" },
    { uid: "6422e64a544ca95fd4433025",name: "TA Studio 6 + Piscine" },
    { uid: "6422ec36544ca95fd443d727",name: "TA Appart 40 + piscine" },
    { uid: "6422ee48544ca95fd4444804",name: "TA Studio 53 + Piscine" },
    { uid: "6422f139544ca95fd4444cec",name: "TA Studio 52 + Piscine" },
    { uid: "6422bfb7178bbe955b475609",name: "RAP Appart 302 + Piscine                         [Video]" },
    { uid: "64215d4a178bbe955b33b7b2",name: "RCS Studio A1" },
    { uid: "64216180178bbe955b340f31",name: "RCS Apartment A2" },
    { uid: "6421754d178bbe955b35d697",name: "RCS Apartment A3" },
    { uid: "64218124178bbe955b364f9e",name: "RCS Studio B1" },
    { uid: "64218819178bbe955b370393",name: "RCS Apartment B2" },
    { uid: "641d7495178bbe955bf71019",name: "HT Chambre Standard" },
    { uid: "641d7df6178bbe955bf76a15",name: "HT Chambre Junior" },
    { uid: "641d805f178bbe955bf76b93",name: "Hôtel Tchero - Chambre Senior" },
    { uid: "641d6a9a178bbe955bf6aa5e",name: "RAP Appart 401 + Piscine" },
    { uid: "641d7a95178bbe955bf7676c",name: "RAP Appart 301 + Piscine" },
    { uid: "641c5a625cb8fd8bd664aafe",name: "RAP Studio 501 + Piscine" },
    { uid: "641c4e6f5cb8fd8bd6640537",name: "RAP Studio 502 + Piscine" },
    { uid: "641c17805cb8fd8bd65f2643",name: "Res AIMSON PALACE Appart 202 + Piscine" },
    { uid: "641c30f55cb8fd8bd661f0eb",name: "RAP Studio 102 + Piscine" },
    { uid: "641b0ef276c4742c9e9f306c",name: "RNP Studio Batouri" },
    { uid: "641b19bd76c4742c9e9fb15a",name: "RNP Chambre Douala" },
    { uid: "641af55276c4742c9e9d4a81",name: "RNP Appart Mora" },
    { uid: "641af89b76c4742c9e9dfffd",name: "RNP Appart Garoua" },
    { uid: "641afde776c4742c9e9e0663",name: "RNP Appart Maroua" },
    { uid: "641ae73776c4742c9e9ad6df",name: "RNP Appart Dschang" },
    { uid: "641abfdb76c4742c9e97b7e4",name: "RNP Appart Kribi" },
    { uid: "64197c9376c4742c9e84a7f6",name: "BLH Chambre 1 + Cuisine" },
    { uid: "641459ae298a4d7002695d3b",name: "HPDR Appart" },
    { uid: "64144276bcecfd181806bec0",name: "HPDR Studio" },
    { uid: "641453678077cd6e80f3d7b8",name: "HPDR Chambre + Baignoire" },
    { uid: "64145dc4298a4d7002697744",name: "HPDR Chambre Standard" },
    { uid: "641444bbbcecfd181806befa",name: "HPDR Chambre luxe " },
    { uid: "64130180bcecfd1818f5556a",name: "RTS Appart 2" },
    { uid: "64130960bcecfd1818f5a00b",name: "RTS Appart 1" },
    { uid: "6412f9f0bcecfd1818f50f25",name: "RTS Appart 3" },
    { uid: "6412d1dfbcecfd1818f344ae",name: "RSN Appart 3 Chambres" },
    { uid: "6412e07bbcecfd1818f3e494",name: "RSN Appart 2 Chambres" },
    { uid: "6412e87cbcecfd1818f449dc",name: "RSN Studio" },
    { uid: "6411b53809073e0d3d2333ad",name: "RC Appart31  2-chambres" },
    { uid: "64119f1c49915502c431886b",name: "RC Studio 42" },
    { uid: "6411aa10e1683a04c80d1105",name: "RC Appart 31  3 Chambres" },
    { uid: "6411984849915502c4314cb7",name: "RC Appart 42" },
    { uid: "6411b84a09073e0d3d2335c1",name: "RC Appart 43" },
    { uid: "6411c302edc96110cee01220",name: "RC Studio 43" },
    { uid: "64102d67baf2b81f434d579f",name: "IM Appart 1" },
    { uid: "6410281ebaf2b81f434b92f9",name: "IML Appart A1" },
    { uid: "640f039cbaf2b81f433a2f5c",name: "RF Appart 602       [Video]" },
    { uid: "640f04bebaf2b81f433a56fd",name: "RF Studio 603    [Video]" },
    { uid: "640ef7d2baf2b81f433815b6",name: "RF Appart 301" },
    { uid: "640b115dbaf2b81f4314de00",name: "RF Studio 303      [Video]" },
    { uid: "640b162bbaf2b81f43151e3f",name: "RF Appart 102       [Video]" },
    { uid: "640b0b17baf2b81f4313f615",name: "KH Appart 6A" },
    { uid: "640f3f3abaf2b81f43410fe2",name: "KH Appart 6B" },
    { uid: "640f4452baf2b81f43413c59",name: "KH Appart 7B" },
    { uid: "640b259cbaf2b81f4316075a",name: "RF Appart 601       [Video]" },
    { uid: "640b008abaf2b81f431386ff",name: "RLC Appart 09 + Piscine" },
    { uid: "640aef8abaf2b81f43129cb2",name: "RLP Studio A001" },
    { uid: "640b0b54baf2b81f4313f72e",name: "RLP Studio 203" },
    { uid: "640b1688baf2b81f43151e9b",name: "RLP Studio 201" },
    { uid: "640ae9bb180f27e6924cd194",name: "SGH chambre 8 + Piscine & Gym" },
    { uid: "6409ff49180f27e69241e786",name: "SGH chambre 7 + piscine &gyms" },
    { uid: "6409afb962bfa03a8dd11014",name: "CP Chambre 110" },
    { uid: "6409b3d262bfa03a8dd1f33d",name: "CP Chambre 103" },
    { uid: "64088ffa62bfa03a8dc2c4a7",name: "RO Appart 303" },
    { uid: "640893ac62bfa03a8dc2c8c5",name: "RO Appart 203" },
    { uid: "64088aae62bfa03a8dc24660",name: "RO Appart 103" },
    { uid: "640895e562bfa03a8dc2f27d",name: "RO Studio 101" },
    { uid: "640884f262bfa03a8dc21d23",name: "RO Chambre 304" },
    { uid: "6408727262bfa03a8dc13d16",name: "RO Studio 205" },
    { uid: "64084b5362bfa03a8dbd941e",name: "RCM Appart Entre Sol" },
    { uid: "64084f7e62bfa03a8dbdeb1a",name: "RCM Appart Premier Niveau" },
    { uid: "6408522962bfa03a8dbe3d8f",name: "RCM Appart Deuxième Niveau" },
    { uid: "64032837ff7f832ea5959a39",name: "RWH Studio  Cotonou + Piscine" },
    { uid: "64032d24ff7f832ea595c34f",name: "RWH Appart Yaounde + Piscine" },
    { uid: "6405b49cff7f832ea5a948da",name: "RWH Appart Kigali + Piscine" },
    { uid: "64030ad1ff7f832ea593aa9b",name: "RLY Chambre 108" },
    { uid: "6403103dff7f832ea593c005",name: "RLY Chambre  201 " },
    { uid: "6403138eff7f832ea594bfc1",name: "RLY Chambre 202 " },
    { uid: "64031591ff7f832ea594c294",name: "RLY Chambre 211" },
    { uid: "640309e1ff7f832ea5939494",name: "SGH chambre 3 + Piscine & Gym" },
    { uid: "6401fc46a37be623e2abbc51",name: "RMPI Appart 4 + Piscine & Gym" },
    { uid: "6401f3cea37be623e2aae41a",name: "RWH Chambre Yamoussoukro + Piscine" },
    { uid: "6401fbdea37be623e2abaa6c",name: "RWH Studio Abuja + Piscine" },
    { uid: "64020558ff7f832ea583aea5",name: "RWH Studio Pretoria + Piscine" },
    { uid: "6401caf2c511d622e27f96c0",name: "RWH Chambre Porto Novo + Piscine" },
    { uid: "6401c7cdc511d622e27f64b6",name: "Résidence G + Piscine" },
    { uid: "6401f02ca37be623e2aa9782",name: "SGH Manoir 6 chambres + Piscine & Gym" },
    { uid: "6401d10ea37be623e2a98924",name: "RWH Chambre Tripoli + Piscine" },
    { uid: "6401dadea37be623e2a9f8d1",name: "RWH Chambre Casablanca + Piscine" },
    { uid: "6401e18aa37be623e2aa0dff",name: "RWH Chambre Addis-Abeba + Piscine" },
    { uid: "6401ef1fa37be623e2aa8573",name: "RWH Chambre Djibouti + Piscine" },
    { uid: "6401ec76a37be623e2aa8299",name: "RMPI Studio 1 +Piscine & Gym" },
    { uid: "6401ef36a37be623e2aa85bc",name: "RMPI Studio 2 + Piscine & Gym" },
    { uid: "6401f198a37be623e2aab84a",name: "RMPI Appart 3 + Piscine & Gym" },
    { uid: "6400b760986383f95b495fe4",name: "REL Studio 2" },
    { uid: "6400bd91986383f95b498622",name: "REL Studio 3" },
    { uid: "6400ab761e2e73d98c0618ca",name: "REL Studio 1" },
    { uid: "64006e3d1e2e73d98c02e1e6",name: "VC Appart 32 Junior Suite       [Video]" },
    { uid: "640070831e2e73d98c02e37c",name: "Villa Centurion - Appart 42 Senior Suite Supérieur" },
    { uid: "640064771e2e73d98c024405",name: "VC Appart 13 Junior Suite" },
    { uid: "63ff5f4c191deecc7158629e",name: "VC Appart 21 Senior Suite       [Video]" },
    { uid: "63ff68f4191deecc71588f92",name: "VC Appart 22 Junior Suite [Vidéo]" },
    { uid: "63ff6bfe191deecc7158c3fc",name: "VC Appart 12 Senior suite supérieur" },
    { uid: "63ff405c191deecc7157e3f2",name: "VC Appart 31 Senior Suite" },
    { uid: "63fe0e32609c33864cb59247",name: "RSC Studio Bafoussam" },
    { uid: "63fe13bd609c33864cb5bbf7",name: "RSC Appart Londres" },
    { uid: "63fe1be9609c33864cb5e2f5",name: "RSC Chambre Batoufam" },
    { uid: "63fe1fca609c33864cb5ec09",name: "RSC Studio Abidjan" },
    { uid: "63fdcee53f7ea928ca94c1b7",name: "HNC Chambre ventilée" },
    { uid: "63fde9683f7ea928ca961f1b",name: "HNC Chambre Climatisée" },
    { uid: "63fded913f7ea928ca96558e",name: "RSC Studio Ngaoundere" },
    { uid: "63fdc08b3f7ea928ca94513e",name: "RM Studio 2" },
    { uid: "63fdc61a3f7ea928ca9458e6",name: "RM Studio 3" },
    { uid: "63fdca7a3f7ea928ca9484f4",name: "RM Chambre 4 ventilée" },
    { uid: "63fdcd6d3f7ea928ca94a6cc",name: "RM Chambre 5 + Cuisine" },
    { uid: "63fdd5483f7ea928ca9529af",name: "RSC Appart New York" },
    { uid: "63fdd83f3f7ea928ca953e27",name: "RSC Appart GuanGhzou" },
    { uid: "63fdded33f7ea928ca958b55",name: "RSC Appart Bangkok" },
    { uid: "63fde10b3f7ea928ca95bd6c",name: "RSC Appart Johanesburg" },
    { uid: "63fde3e83f7ea928ca95df2e",name: "RSC Studio Lille" },
    { uid: "63fde6a33f7ea928ca95e064",name: "RSC Studio Mbouda" },
    { uid: "63fdbdbc3f7ea928ca9430c8",name: "RM Studio 1" },
    { uid: "63f9defe446ca357988733aa",name: "RLPN Studio 2 " },
    { uid: "63f9e488446ca3579887b319",name: "RLPN Appart" },
    { uid: "63f9d68e446ca3579886813d",name: "RA Studio 101" },
    { uid: "63f9c749446ca357988629c0",name: "RLPN Studio 1" },
    { uid: "63f8e958446ca3579883055d",name: "RDL Appart 201" },
    { uid: "63f8c980446ca35798800b52",name: "RM Appart 1" },
    { uid: "63f8cbf6446ca35798804a42",name: "RM Appart 2" },
    { uid: "63f8b45d446ca357987ee349",name: "RM Studio " },
    { uid: "63f8bc37446ca357987f7cdd",name: "RM Chambre + Cuisine" },
    { uid: "63f876d0446ca357987addc7",name: "HR Studio 402" },
    { uid: "63f87eeb446ca357987b55c0",name: "HR Studio 203" },
    { uid: "63f882c5446ca357987b6d82",name: "HR Studio 202" },
    { uid: "63f8a485446ca357987dd0b1",name: "RDL Appart 301" },
    { uid: "63f8a805446ca357987de4ae",name: "RDL Appart 302" },
    { uid: "63f7671a446ca35798746ae5",name: "HR Appart 300" },
    { uid: "63f76b97446ca3579874f27a",name: "HR Appart 201" },
    { uid: "63f75c59446ca35798739872",name: "HR Studio 303" },
    { uid: "63f7679c446ca35798746b11",name: "HR Appart 301" },
    { uid: "63f88a46446ca357987c02dd",name: "RA Studio 103" },
    { uid: "63f729c0c2c38b279221851f",name: "RN Appart Gauche" },
    { uid: "63f72ccdc2c38b2792219ed2",name: "RN Studio Logement des Grâces" },
    { uid: "63f5e90cc2c38b279217aa23",name: "RTS Chambre Istanbul 206" },
    { uid: "63f5ebfbc2c38b279217e0b6",name: "RTS Chambre Madrid 205" },
    { uid: "63f5eeefc2c38b2792182696",name: "RTS Chambre Berlin 203 VIP + Cuisine" },
    { uid: "63f47ffbb519a1ca4258e11e",name: "RTS Chambre Addis Abeba 204" },
    { uid: "63f48901b519a1ca42590d75",name: "RTS Chambre Bangkok 106" },
    { uid: "63f48ad2b519a1ca4259126d",name: "RTS Chambre Lagos 102" },
    { uid: "63f48cabb519a1ca4259160c",name: "RTS Chambre Jakarta 104" },
    { uid: "63f48e99b519a1ca42591870",name: "RTS Chambre New-Delhi 105" },
    { uid: "63f49075b519a1ca42599ae8",name: "RTS Chambre Abidjan 202" },
    { uid: "63f491e7b519a1ca4259a650",name: "RTS Chambre Osaka 101 VIP + Cuisine" },
    { uid: "63f49880b519a1ca425a00fc",name: "RTS Chambre Guangzhou 103 VIP + Cuisine" },
    { uid: "63f49c81b519a1ca425a4b17",name: "RTS Studio Tokyo 107" },
    { uid: "63f4a05cb519a1ca425afa00",name: "RTS Studio Paris 207" },
    { uid: "63f0906ffdbb1b57cc448253",name: "HM Chambre Suite" },
    { uid: "63f095eefdbb1b57cc44b043",name: "Mbanya Hôtel - Chambre Standard" },
    { uid: "63ef4b4cf69b8d26f8539fd4",name: "RL Studio 1     [Video]" },
    { uid: "63ef6035f69b8d26f854748b",name: "RNP Appart Limbé" },
    { uid: "63ef774bfdbb1b57cc42f8c8",name: "RNP Studio Noun" },
    { uid: "63ee4a7ff69b8d26f8501dcb",name: "HGH Chambre Standard" },
    { uid: "63ee55b5f69b8d26f8505883",name: "AH Chambre Standard" },
    { uid: "63ee58f1f69b8d26f850802d",name: "AH Chambre Confort" },
    { uid: "63ee1ef6f69b8d26f84de2d8",name: "HGH Chambre Confort" },
    { uid: "63ecb67fbd521ef23bb96335",name: "HTP Chambre double lits + Bord de mer" },
    { uid: "63eca672174701ec48d285a2",name: "HTP Chambre Grand Lit + Bord de mer" },
    { uid: "63ecc298bd521ef23bba0040",name: "RLD Studio Normal 1" },
    { uid: "63ecc6f5bd521ef23bba1686",name: "RLD Grand Studio " },
    { uid: "63ecdde8bd521ef23bba5c9d",name: "HTP Chambre VIP + Bord de mer" },
    { uid: "63ece8437109e2faee70db1f",name: "HTP Chambre Ventilée Standard + Bord de mer" },
    { uid: "63ecb3ac174701ec48d29e86",name: "RLD MB Studio" },
    { uid: "63ecba0abd521ef23bb97b12",name: "RLD Studio Normal 2" },
    { uid: "63ecbc67bd521ef23bb9835e",name: "RLD Appart" },
    { uid: "63eb4fd8c9a4c5beace24a6b",name: "HJ Chambre Standard + Bord de mer" },
    { uid: "63eb6165c9a4c5beace26a8a",name: "HJ Studio 202 + Bord de mer" },
    { uid: "63eb7127c9a4c5beace70f3d",name: "HJ Appart 4-1  + Bord de mer" },
    { uid: "63eb7b5bc9a4c5beace77837",name: "HJ Chambre Campement + Bord de mer" },
    { uid: "63eb9ab51bf53ace2aa473ae",name: "Hôtel Tara Plage: Appartement + Bord de mer" },
    { uid: "63eb85f9c9a4c5beace7beae",name: "IKH Studio Bamenda" },
    { uid: "63ec9aa0174701ec48d22e7e",name: "IKH Chambre Yaounde" },
    { uid: "63ec9c73174701ec48d233ff",name: "IKH Chambre Douala" },
    { uid: "63ec9e30174701ec48d25c4b",name: "IKH chambre Bafoussam" },
    { uid: "63ec9fd1174701ec48d25dd1",name: "IKH chambre Bertoua" },
    { uid: "63eca385174701ec48d27037",name: "IKH chambre Garoua" },
    { uid: "63ecb75fbd521ef23bb96442",name: "IKH Chambre Maroua" },
    { uid: "63ecbaa5bd521ef23bb97c0f",name: "IKH Appart Maisonnette" },
    { uid: "63ecbdffbd521ef23bb98561",name: "IKH Chambre BUEA" },
    { uid: "63eb4769c9a4c5beace1e0ba",name: "ABH Chambres + Bord de mer " },
    { uid: "63ea54b3733af3979a6742ce",name: "RCP Appart 04 + Bord de mer" },
    { uid: "63ea4e7f733af3979a66e3a2",name: "RCP Appart 02 + Bord de mer" },
    { uid: "63ea5209733af3979a672df6",name: "RCP Appart 03 + Bord de mer" },
    { uid: "63ea47d4733af3979a66a44f",name: "HBS Appart 4 + Bord de mer" },
    { uid: "63ea4ad5733af3979a66c9be",name: "HBS Chambre 5 + Bord de mer" },
    { uid: "63ea43525527d4ff55d6cac3",name: "HBS Chambre 3 + Bord de Mer" },
    { uid: "63ea34705527d4ff55d69435",name: "HBS Chambre 1 + Bord de Mer" },
    { uid: "63ea3ce85527d4ff55d696a0",name: "HBS  Chambre 2 + Bord de Mer" },
    { uid: "63ea451d5527d4ff55d6e2de",name: "RCP Appart 01 + Bord de mer" },
    { uid: "63ea32cf5527d4ff55d693c4",name: "RMHD Appart 2" },
    { uid: "63ea34de5527d4ff55d694f7",name: "RMHD Appart 3" },
    { uid: "63ea3f2c5527d4ff55d69714",name: "RMHD Appart 5" },
    { uid: "63ea46145527d4ff55d70913",name: "RMHD Appart 4" },
    { uid: "63ea4b20733af3979a66ca5d",name: "RMHD Appart 6" },
    { uid: "63ea4d73733af3979a66cebd",name: "RMHD Appart 7" },
    { uid: "63ea4f0d733af3979a66f35a",name: "RMHD Appart 8" },
    { uid: "63e64fac5527d4ff55d2168f",name: "OR Studio ROC+ Piscine" },
    { uid: "63e6518e5527d4ff55d22564",name: "OR Studio Annexe gauche + Piscine" },
    { uid: "63ea2fdd5527d4ff55d67532",name: "RMHD Appart 1" },
    { uid: "63e6028af586b49c5b440ea8",name: "RLCSJ Appart 4A" },
    { uid: "63e60d1af586b49c5b445a21",name: "RLCSJ Studio 3B" },
    { uid: "63e61239f586b49c5b449d7c",name: "RLCSJ Appart 4B" },
    { uid: "63e614d8f586b49c5b449e4b",name: "RLCSJ Studio 2B" },
    { uid: "63e3a96aaf56ca481cab2769",name: "RNP Chambre Logone + Cuisine" },
    { uid: "63e3b78baf56ca481cab946b",name: "RNP Studio Douala" },
    { uid: "63e396e9af56ca481caadf80",name: "RNP Appart Belabo" },
    { uid: "63e39997af56ca481caae11d",name: "RNP Appart Bangangte" },
    { uid: "63e11d8c76069bde9fd0615c",name: "RV Appart A3       [Video]" },
    { uid: "63e0c0195a26e23a7924dd25",name: "RV Appart D3" },
    { uid: "63e0c57a76069bde9fce77ed",name: "RV Appart B3" },
    { uid: "63e0d63e76069bde9fce8b49",name: "RV Appart A2" },
    { uid: "63de63415a26e23a7922077b",name: "RDH Appart 1A1" },
    { uid: "63de35055a26e23a7920d776",name: "RSM Studio 4" },
    { uid: "63de40ed5a26e23a79210154",name: "RSM Studio 6" },
    { uid: "63de44e65a26e23a7921553c",name: "RSM Studio 1" },
    { uid: "63de5e995a26e23a7921fa5e",name: "RDH Studio 1S2" },
    { uid: "63de2a495a26e23a7920037e",name: "RSM Studio 5 " },
    { uid: "63db9ff24a2915fbe5721e80",name: "RR Studio 2ème Etage" },
    { uid: "63db8e484a2915fbe571ec81",name: "RR Studio 1er Etage" },
    { uid: "63dbaaac4a2915fbe57294a2",name: "OR Studio Annexe droite + piscine" },
    { uid: "63daa7e44a2915fbe570ca97",name: "REL Studio" },
    { uid: "63da3fe57937c27cc5b35bcd",name: "RP Appart 001" },
    { uid: "63da54c07937c27cc5b3c2d6",name: "RLM Chambre 6" },
    { uid: "63da60d77937c27cc5b42847",name: "RLM Chambre 8 + Jacuzzi" },
    { uid: "63da74194a2915fbe570335a",name: "RLM Chambre 9" },
    { uid: "63da7d3c4a2915fbe5706935",name: "RLM Chambre 1 + Cuisine" },
    { uid: "63da839e4a2915fbe57099bc",name: "RLM Chambre 4 + Cuisine" },
    { uid: "63da89094a2915fbe5709c8e",name: "RLM Chambre 3 + Cuisine" },
    { uid: "63da38f37937c27cc5b332ef",name: "RLM Chambre 7 + Cuisine" },
    { uid: "63d9243e7937c27cc5aa0bf0",name: "RJS Appart Homey1 + Jacuzzi" },
    { uid: "63d910cd7937c27cc5a9a3f6",name: "RJS Appart Homey2" },
    { uid: "63d7a3ae76643371bce7c3ad",name: "REL Studio " },
    { uid: "63d7aec676643371bce7fa4a",name: "REL Studio A16" },
    { uid: "63d7bb4176643371bce8a803",name: "REL Appart 19" },
    { uid: "63d7c6b77937c27cc5a65fe0",name: "REL Appart 21" },
    { uid: "63d7dd3e7937c27cc5a6d20e",name: "REL Appart 20" },
    { uid: "63d8d8bb7937c27cc5a88543",name: "REL Appart A17" },
    { uid: "63d3920a2c039ea30ff50178",name: "RLC Studio 03 + Piscine" },
    { uid: "63d39a9d2c039ea30ff67808",name: "RLC  Duplex L9 + Piscine" },
    { uid: "63d27a1d2c039ea30feafef4",name: "RMMF Appart 6" },
    { uid: "63d2a1122c039ea30fed5c63",name: "RMMF Studio 3" },
    { uid: "63d2a6522c039ea30fef5e07",name: "RMMF Appart 4" },
    { uid: "63d2631b2c039ea30fe992c3",name: "RSCI T Appart 1" },
    { uid: "63d10b2fad016a6e53f58a0d",name: "RT Chambre 15" },
    { uid: "63d11b91ad016a6e53f60040",name: "RT Studio 10" },
    { uid: "63d121b1ad016a6e53f60498",name: "RT Chambre 4" },
    { uid: "63d1296aad016a6e53f66d33",name: "RT Chambre 7" },
    { uid: "63d1536cad016a6e53f7583f",name: "RT Studio 5" },
    { uid: "63d25cf92c039ea30fe98970",name: "RBS Appart A2" },
    { uid: "63d26e322c039ea30fea2d21",name: "RBS Studio S2" },
    { uid: "63cfec718a6f6bd1b141fd4a",name: "RM Studio 2" },
    { uid: "63cff8338a6f6bd1b142744f",name: "RT Appart 8" },
    { uid: "63cfd4f58a6f6bd1b14174a1",name: "RM Appart B2" },
    { uid: "63cfc83c8a6f6bd1b140f4e9",name: "R A&J Appart 104     [Video]" },
    { uid: "63cfb3e48a6f6bd1b140a505",name: "RFP Studio Sysley                     [Video]" },
    { uid: "63cfb7638a6f6bd1b140a88e",name: "RFP Appart Wesley                       [Video]" },
    { uid: "63cf7b478a6f6bd1b1403c07",name: "RFP Chambre Ivana                      [Video]" },
    { uid: "63cf7c708a6f6bd1b1403d6f",name: "RFP Studio Loan                  [Video]" },
    { uid: "63cf1c8e8a6f6bd1b140138f",name: "RFP Appart Sydney              [Video]" },
    { uid: "63cec9398a6f6bd1b13fe823",name: "RFP Appart Tiffany" },
    { uid: "63ced0be8a6f6bd1b13ffaad",name: "RFP Chambre Familia                   [Video]" },
    { uid: "63cec2818a6f6bd1b13fe2f6",name: "RFP Appart Stephanie" },
    { uid: "63cecca98a6f6bd1b13fe8f6",name: "RFP Chambre Kenneth                     [Video]" },
    { uid: "63ca72e66b535c8f42caefc5",name: "WDR Appart 201A                             [Video]" },
    { uid: "63ca79cf6b535c8f42cb2fe2",name: "WDR Appart 202B" },
    { uid: "63ca7fd96b535c8f42cb48bf",name: "WDR Appart 101A                [Video]" },
    { uid: "63ca98b46b535c8f42cb9ec2",name: "RMD Chambre Confort" },
    { uid: "63ca9d636b535c8f42cbf853",name: "RMD Chambre Standard" },
    { uid: "63cab198ce44669a1c6dd235",name: "RLP Appart 204   [Video]" },
    { uid: "63cab77bce44669a1c6dea3b",name: "RLP Chambre A202" },
    { uid: "63cabc09ce44669a1c6df466",name: "RLP Appart A302       [Video]" },
    { uid: "63cad5098faa539de1fd9592",name: "RLP Appart A401" },
    { uid: "63ca64a06b535c8f42ca9a7d",name: "WDR Chambre 02" },
    { uid: "63ca6a0a6b535c8f42caafc6",name: "WDR Appart 302B                             [Video]" },
    { uid: "63ca5c6fbe4418539c732bb4",name: "WDR Appart 102B                             [Video]" },
    { uid: "63ca5361be4418539c731060",name: "WDR Appart 301A                             [Video]" },
    { uid: "63c96163be4418539c724b6e",name: "WDR Studio 203S" },
    { uid: "63ca87576b535c8f42cb76fe",name: "RMD Chambre Luxe" },
    { uid: "63caa2946b535c8f42cc0299",name: "RLP Studio A101" },
    { uid: "63ce9d278a6f6bd1b13f3d2f",name: "RMKC Studio Gauche 2e niveau" },
    { uid: "63ceaaf88a6f6bd1b13f5b4a",name: "R A&J Appart 303 " },
    { uid: "63c952a9fbbc6b504c60744a",name: "RBA Appartement                             [Video]" },
    { uid: "63c9240710ef254e8ba608a1",name: "TR Appart 3 Chambres" },
    { uid: "63c93a86fbbc6b504c60376c",name: "RBA Studio                              [Video]" },
    { uid: "63c919085878e82cde2b62c4",name: "TR Appart 2 Chambres" },
    { uid: "63c90c905878e82cde2b1712",name: "TR Appart 1 chambre" },
    { uid: "63c81330c2bc6c266c852b3d",name: "TFR Studio Addis Abeba + Gym [Video]" },
    { uid: "63c7fddcc2bc6c266c84cbc5",name: "TFR Appart Nairobi + Gym" },
    { uid: "639b21c5b160693abf669d99",name: "MJ Classic room" },
    { uid: "639b28a5513a9b54ea154997",name: "MJ Standard room " },
    { uid: "639b33c803f4437770206460",name: "MJ Standard room 1       [Video]" },
    { uid: "639b064d4f013fa7c7eb4c55",name: "RF APPART 01" },
    { uid: "639b0dd0f32e8fde61f12926",name: "MJ Suite présidentielle 1 + Cuisine" },
    { uid: "639a088ae33f4e7b3a4ceaf7",name: "RF APPART 8" },
    { uid: "6399fe11e33f4e7b3a4cb72b",name: "TR  Appart 101A" },
    { uid: "6399992224a7aea0692772ae",name: "PG S01" },
    { uid: "6399a11424a7aea069279169",name: "PG S03" },
    { uid: "63989f4d24a7aea06927292e",name: "PG S02" },
    { uid: "6398902622f37570f6635a75",name: "TR 101B Chambre" },
    { uid: "639896c324a7aea06927228b",name: "TR 101C" },
    { uid: "6398733408db889171ddde51",name: "RC Studio S2-4" },
    { uid: "639879a008db889171ddedb1",name: "RC Studio S1-1" },
    { uid: "63987ce408db889171de16d8",name: "TR Appart 102C" },
    { uid: "63982b73a6a1c7d93413a45c",name: "RSC Chambre 2 + Cuisine      [Video]" },
    { uid: "6398330e08db889171dd2226",name: "RSC studio 09" },
    { uid: "63984cdb08db889171dd5bb9",name: "RT Appart France" },
    { uid: "63975c5ca6a1c7d93411e3e2",name: "RSC studio 04" },
    { uid: "63971df3a6a1c7d93411780e",name: "RSC Studio 06       [Video]" },
    { uid: "6391e5807d10b3d95f4abc3a",name: "RC Studio S2-2" },
    { uid: "6391eb8ed84b86f4bd145a09",name: "RC Studio S2-3" },
    { uid: "6391f9e3ef47701b723c33fd",name: "RC Appart S2-1" },
    { uid: "6391fee5ef47701b723c3855",name: "RC Appart S1-5" },
    { uid: "63920b7be12e3985e2c56ce4",name: "RC Studio S1-4" },
    { uid: "6391c4e57176bc14708a2ed2",name: "RC Studio S2-1" },
    { uid: "6391ce4c7176bc14708a3a23",name: "RC Studio S2-5" },
    { uid: "6391a7a55c78d191069125b9",name: "RC Studio S1-2" },
    { uid: "6389fdff9ae8b544428a4567",name: "RT Studio Belgique + Piscine + Gym" },
    { uid: "6389f5118c75f34a79c7ba69",name: "RT Room Nigeria + Piscine" },
    { uid: "63889f23b5f8d86fdcbd8022",name: "RT Cameroun Studio + Piscine " },
    { uid: "6388a802b5f8d86fdcbdc640",name: "RT Appart Etats Unis + Piscine               [Video]" },
    { uid: "6389ef058c75f34a79c7a013",name: "RT Appart Canada + Piscine" },
    { uid: "6389f32e8c75f34a79c7a146",name: "RT Studio Afrique du Sud + Piscine" },
    { uid: "6389f4d68c75f34a79c7b46b",name: "RT Studio Suisse + Piscine" },
    { uid: "6389f88b8c75f34a79c7ff3b",name: "RT Chambre Dubaï + Piscine " },
    { uid: "6388828c1de664a048f443be",name: "RT Appart 3-chambres Allemagne + Piscine" },
    { uid: "6388818d1de664a048f42d10",name: "RDG Princesse Appartement 3-chambres" },
    { uid: "638893b11de664a048f46bed",name: "RDG Princesse Appartement 2-Chambres" },
    { uid: "63889cf396c89550a3c5421a",name: "RDG Princesse Studio" },
    { uid: "63878efc166022e613f01bd1",name: "MB Studio 304" },
    { uid: "6387955f873fcd0435258a42",name: "MB Appart 401" },
    { uid: "63879da7873fcd043525a11e",name: "MB Appart 402                 [Video]" },
    { uid: "63878ba4166022e613f01426",name: "MB Appart 304" },
    { uid: "6384ba3e8aa0b50cffd0b369",name: "RLR Chambre" },
    { uid: "6384c91a8aa0b50cffd0d865",name: "RLR Studio" },
    { uid: "6384cbc48aa0b50cffd0dd55",name: "LR Appartement 2-Chambres" },
    { uid: "6384cd518aa0b50cffd0df41",name: "RLR 3-Chambres" },
    { uid: "6384cfd2a6572e03de82619b",name: "RLR Duplex à 5 Chambres" },
    { uid: "6385f49c7a9d8dc08b5fc540",name: "MB Studio 401" },
    { uid: "638216e88eb4ac62100ad129",name: "RBB Appartement 3-Chambres                     [Video]" },
    { uid: "63821f92ff1c7b8d80a63232",name: "RBB Appartement 2-Chambres" },
    { uid: "638222998210a9ae14a6058c",name: "Res BELMANN Appart 1-Chambre" },
    { uid: "63820c19566f9710cc28e824",name: "Res LOUMIA PREMIUM Studio 1-Chambre" },
    { uid: "6381fcc5566f9710cc28b975",name: "LP Appartement 2-Chambres" },
    { uid: "6381f65de39b57e0d6503ebd",name: "RA Studio S2 + Piscine & Gym [Vidéo]" },
    { uid: "6381fd02566f9710cc28ba5e",name: "RA Studio S3 + Piscine & Gym [Vidéo]" },
    { uid: "6381febd566f9710cc28bc33",name: "RA Studio S4 + Piscine & Gym [Vidéo]" },
    { uid: "63823bc28aa0b50cffcdb070",name: "FR 402 Room" },
    { uid: "6381e692aafc10a04372d789",name: "RB Appartement 2-Chambres" },
    { uid: "6381ebc3aafc10a04372f554",name: "RB Studio 1-Chambre" },
    { uid: "6381e299aafc10a043729a7f",name: "RA Appart A5 + Piscine & Gym" },
    { uid: "6381e2b2aafc10a043729aa3",name: "RA Appart A6 + Piscine & Gym [Video]" },
    { uid: "6381ee6e37b7b9d29306119d",name: "RA Appart A3 + Piscine & Gym [Vidéo]" },
    { uid: "6381f01b37b7b9d2930617e5",name: "RA Appart A4 + Piscine & Gym  [Video]" },
    { uid: "6381cf22ae3a7da3d0a5fc22",name: "FR 404 Chambre + Douche & Cuisine" },
    { uid: "6381c523ae3a7da3d0a5ed65",name: "RC Appart 601" },
    { uid: "6380a9d9ae3a7da3d0a5474d",name: "FR 303 Chambre + Douche & Cuisine" },
    { uid: "63808ef6ae3a7da3d0a4f8c7",name: "RC Appart 301" },
    { uid: "637f86de347b43af25bb0fda",name: "FFG Apartment 1" },
    { uid: "637f94fd347b43af25bb29e1",name: "FFG Apartment 4" },
    { uid: "637f99aa1d1433afdf4074b7",name: "FFG Studio 9" },
    { uid: "637e416da08c5fcb0fee8a18",name: "CVV Appart 402" },
    { uid: "637e39640be08e4f39d8c1e4",name: "CVV Room 603" },
    { uid: "637e3b090be08e4f39d8c359",name: "CVV Studio 605" },
    { uid: "637e3c870be08e4f39d8c4e1",name: "CVV Studio 602" },
    { uid: "637e4165a08c5fcb0fee89fa",name: "CONVIVIUM Appart 401 + Piscine " },
    { uid: "637e05620be08e4f39d7e2f5",name: "Stuttgart Studio A6" },
    { uid: "637e0af40be08e4f39d7fdbe",name: "Stuttgart appart 005 VIP3" },
    { uid: "637e0f1b0be08e4f39d80792",name: "Stuttgart Appart 008 KENCHAIR" },
    { uid: "637e17c50be08e4f39d81253",name: "Stuttgart Appart VIP5" },
    { uid: "637dd3330be08e4f39d7abaf",name: "Stuttgart Appart Plus One" },
    { uid: "637de6b20be08e4f39d7d620",name: "Stuttgart Appart Plus Two" },
    { uid: "637dfc960be08e4f39d7e1c8",name: "Stuttgart Appart VIP1" },
    { uid: "637e0df50be08e4f39d806b8",name: "Stuttgart Appart VIP2" },
    { uid: "637e16350be08e4f39d80fb4",name: "Stuttgart Appart VIP4" },
    { uid: "637c8b0dc975998f8524ec38",name: "Stuttgart Appart A1" },
    { uid: "637cf3b0c975998f8525e1f9",name: "Stuttgart studio A2" },
    { uid: "637cf61dc975998f8525e3d7",name: "Stuttgart studio A3" },
    { uid: "637cfa4bc975998f8525e565",name: "Stuttgart Studio A4" },
    { uid: "637cfb92c975998f8525e6f8",name: "Stuttgart Appart A5" },
    { uid: "637cfefc972b3845ef9d1213",name: "Stuttgart Studio A8" },
    { uid: "636d07cdbc409158f64fcf5b",name: "SDL Lucie de Londres       [Video]" },
    { uid: "636d1130b87512f74e2884d3",name: "SDL Lucienne de Lagos       [Video]" },
    { uid: "636d199b8c115716411c3f9b",name: "SDL Madeleine de Bruxelles                    [Video]" },
    { uid: "636d29616890742a481573e9",name: "SDL Rose du Camer     [Video]" },
    { uid: "636d4505231a3163f2b19e6e",name: "SDL Jaqueline de Dubai" },
    { uid: "636c47f61b4b24e72c19a1a2",name: "CDA Studio RDC2 + Piscine" },
    { uid: "636c52b587a78aececde1b05",name: "CDA Studio RDC3 + Piscine" },
    { uid: "636c565963ac991529f5baa3",name: "CDA Studio 2 + Piscine" },
    { uid: "636ac473b16df8daa4746ade",name: "MB Studio 301" },
    { uid: "636ac5d6b16df8daa4746c77",name: "MB Studio 302" },
    { uid: "636ad081b16df8daa474703d",name: "MB Studio 303" },
    { uid: "636ad27bdc412e1e73ac50ce",name: "MB Studio 404" },
    { uid: "636ad511dc412e1e73ac579b",name: "GH Appart P7" },
    { uid: "636b71c35e050b331ab001f0",name: "GH Appart P3" },
    { uid: "636b78b35e050b331ab0438e",name: "TIF Appart A3" },
    { uid: "636b80ec02f9468eeb8f22da",name: "GH Studio A" },
    { uid: "636b840202f9468eeb8f31d1",name: "GH Chambre B" },
    { uid: "637251c459b3e9e633398fd9",name: "Villa LCDN + Piscine" },
    { uid: "636a81f8ffe5e66cb8cbfddd",name: "MB Appart 204" },
    { uid: "636a86ccffe5e66cb8cc22b4",name: "MB Appart 301" },
    { uid: "636a88c8ffe5e66cb8cc2466",name: "MB Appart 302" },
    { uid: "636a8a1affe5e66cb8cc25e3",name: "MB Appart 303 2- Chambres" },
    { uid: "636a8cd7ffe5e66cb8cc28d7",name: "MB Appart 404" },
    { uid: "636abab3ffe5e66cb8cc3877",name: "MB Studio 403  [Video]" },
    { uid: "636abe1affe5e66cb8cc3be7",name: "MB Studio 201" },
    { uid: "636ac023ffe5e66cb8cc3d62",name: "MB Studio 202" },
    { uid: "636ac0feffe5e66cb8cc3ee3",name: "MB Studio 203" },
    { uid: "636ac1dcffe5e66cb8cc4065",name: "MB Studio 204" },
    { uid: "63612b5906b74de0cacf780a",name: "MB Appart 202 - 2 chambres" },
    { uid: "635ff92206b74de0cace51be",name: "MB Appart 201" },
    { uid: "635beda49a5a8a22062ff816",name: "TA Logpom Studio" },
    { uid: "635bd495588a4794adffa56b",name: "RTA Chambre Kribi " },
    { uid: "635be871588a4794adffaf6f",name: "TA Japoma room" },
    { uid: "635be970588a4794adffb06c",name: "TA Bonamoussadi apart" },
    { uid: "635bea21588a4794adffb16f",name: "TA Bonaberi Studio" },
    { uid: "635bead09a5a8a22062fe293",name: "TA Bali Apartment" },
    { uid: "635bd1e7588a4794adff9b9a",name: "TA Brussels Studio" },
    { uid: "635bd002588a4794adff956e",name: "TA Deira Room" },
    { uid: "635bd0f4588a4794adff969d",name: "RTA Studio Miami  " },
    { uid: "635bcf3c588a4794adff912c",name: "RTA Studio Limbe" },
    { uid: "635bca9a588a4794adff6e5a",name: "THE ADDRESS Foumban Apartment" },
    { uid: "635bcdc0588a4794adff86b9",name: "RTA Appart Buea" },
    { uid: "635bc60fd6417783f3cb38a0",name: "TA Kinshasa Apartment" },
    { uid: "635bc79cd6417783f3cb4025",name: "TA Barcelone Studio " },
    { uid: "635bc88d588a4794adff5db1",name: "RTA Appartement Milan " },
    { uid: "635bbf5a0e924420217435bc",name: "TA Bandjoun Apartment " },
    { uid: "635bc0a80e9244202174437d",name: "RTA Appart Bandjoun " },
    { uid: "635bc2830e924420217476c1",name: "RTA Studio Paris" },
    { uid: "635bc4720e924420217495fc",name: "TA Genève Apartment " },
    { uid: "635bc6d8d6417783f3cb3f9a",name: "RTA Appartement Malabo " },
    { uid: "634de059d85c58bf905019a7",name: "WoWDivalicious " },
    { uid: "634807533aff3f43a45ae109",name: "L13 - Appart 2 chambres" },
    { uid: "63459f881101071f8a1f3563",name: "FAB Apartments 4A" },
    { uid: "63401575970eea02dbd54b7f",name: "LCDN Mango Room 101" },
    { uid: "634019ae5370491d97e6241b",name: "LCDN Kiwi Room 102       [Video]" },
    { uid: "63401b505370491d97e628fe",name: "LCDN Coconut Room 104       [Video]" },
    { uid: "63401caa5370491d97e62987",name: "LCDN Papaya Room 105" },
    { uid: "63401d795370491d97e62a22",name: "LCDN Banana Room 106       [Video]" },
    { uid: "63401e875370491d97e62ab7",name: "LCDN Strawberry Studio 202       [Video]" },
    { uid: "63401f6b5370491d97e62b52",name: "LCDN Blueberry 201  [Video]" },
    { uid: "6340203e5370491d97e62bf3",name: "LCDN Blackberry Room 203       [Video]" },
    { uid: "6340214b5370491d97e62d1e",name: "LCDN Mandarin Room 103" },
    { uid: "633ec449d8bef57b1018416a",name: "SMB Appart Simbcoinswap + Gym [Video]" },
    { uid: "633ec5c41f30e780176162ce",name: "SMB Studio BinanceCoin + Gym       [Video]" },
    { uid: "633ec6911f30e78017616c52",name: "SMB Studio Bittoren + Gym       [Video]" },
    { uid: "633ec7c31f30e78017617124",name: "SC Appart Shiba Inu + Gym" },
    { uid: "633ec49ed8bef57b1018422d",name: "Simb Appart STELLAR + Gym" },
    { uid: "633ec8091f30e780176171ac",name: "SC Appart Limocoinswap + Gym [Video]" },
    { uid: "633ec559d8bef57b10184390",name: "SMB Studio Bitcoin + Gym" },
    { uid: "633ea3ecab6e034231e51b89",name: "Meublé 2-Chambres Nkogmondo" },
    { uid: "633ea564ab6e034231e51c62",name: "Appartement 2-Chambres Nkogmondo" },
    { uid: "633d93548890e91c8f99cab5",name: "Suite présidentielle " },
    { uid: "633d95168890e91c8f99cb38",name: "Suite Princesse " },
    { uid: "633d90d58890e91c8f99c879",name: "Suite Royale" },
    { uid: "633d58bb8890e91c8f9931c7",name: "Room A3 + Piscine" },
    { uid: "633d59e38890e91c8f993971",name: "Room A8 + Piscine" },
    { uid: "633d5b178890e91c8f994148",name: "Room A7 + Piscine" },
    { uid: "633cb27e93f5daa882190494",name: "Studio RIAD A1 + Piscine" },
    { uid: "633cb49a93f5daa88219057d",name: "Studio RIAD A2 + Piscine" },
    { uid: "633c47a993f5daa88218eb7b",name: "Miromer A2 YJ        [Video]" },
    { uid: "633c492193f5daa88218ec30",name: "Miromer S1 YJ" },
    { uid: "633c238144bbbb6c665148fe",name: "Res Benou 3B" },
    { uid: "633c2621e551c7a3e6cd19aa",name: "Res Benou 3A" },
    { uid: "633b03583b0ee2bd959a3f1e",name: "Athena Appart" },
    { uid: "633b05273b0ee2bd959a40f8",name: "Arthemis Studio [Video]" },
    { uid: "633b069d3b0ee2bd959a4191",name: "Olympe appart       [Video]" },
    { uid: "6336dce5b3f7971ec9057f33",name: "JANEA Villa Bonapriso + Piscine" },
    { uid: "6335a39e459348799773d1e4",name: "HJ Chambre Single " },
    { uid: "6335a66dd95d30b5285fe4b9",name: "HJ Chambre Single Standard " },
    { uid: "6331a28d10cb886fb342eb99",name: "Dajobar 203" },
    { uid: "6331a2dc10cb886fb342ebe7",name: "Dajobar 202" },
    { uid: "6331a4bb10cb886fb342f5ed",name: "Dajobar 302" },
    { uid: "63284fa110cb886fb33e44cd",name: "Résidence LM Appart 3A - 3 chambres" },
    { uid: "6328516e10cb886fb33e45a1",name: "Résidence LM 2A - 2 Chambres" },
    { uid: "6328537410cb886fb33e464c",name: "Résidence LM Appart 2B - 2 chambres" },
    { uid: "632868c910cb886fb33e6817",name: "Résidence LM RDC - Studio 1 chambre" },
    { uid: "6319ed16f12566ab7e5c2ffc",name: "Express Logement Room 2" },
    { uid: "6319f05af12566ab7e5c31c9",name: "Express Room 1" },
    { uid: "630e30e5f584b3d4b944ad0e",name: "RH 103" },
    { uid: "630e3290f584b3d4b944ad9b",name: "RH Studio 102" },
    { uid: "630e33fdf584b3d4b944ae42",name: "Royal Home 202" },
    { uid: "6304eb8ef584b3d4b942ce04",name: "Beau Rivage standard" },
    { uid: "6304eea2f584b3d4b942ce9d",name: "Beau Rivage standard+" },
    { uid: "630351055393fb25d9bae99e",name: "Tropiq Home 0a" },
    { uid: "630353dc5393fb25d9baea72",name: "Tropiq Home 0b" },
    { uid: "62d569ab9d574be79c719272",name: "WTP 3F Apartment" },
    { uid: "62d56d1c9d574be79c71993e",name: "WTP 2A Studio" },
    { uid: "62cf034b824e4ee77d3114b9",name: "WTP 1B Studio" },
    { uid: "62cdd31505b2f1fcb056067c",name: "WTP 4F Apartment" },
    { uid: "62cdd57205b2f1fcb0560712",name: "WTP 1C Studio (VIP)" },
    { uid: "62cdde0605b2f1fcb05609ca",name: "WTP 1A Studio" },
    { uid: "62b4942a710db2e65a2033ab",name: "GH Suite 1C 12e" },
    ];


    return (
        <div>
          <h1 className={title}>Sitemap</h1>
          <h2>Landing pages</h2>
          <ul>
            <li><a href="/">Page d'acceuil Logements</a></li>
            <li><a href="/blog">Blog</a></li>
            <li><a href="/guide-touristique">Guides Touristiques</a></li>        
          </ul>
          <h2>Announces de Logements</h2>
            <ul>
            {listingUIDs.map((listing) => (
                <li key={listing.uid}>
                <a href={`/details-announce-${listing.uid}`}>{listing.name}</a>
                </li>
            ))}
            </ul>

            <h2> Articles de blog</h2>

            <ul>
                <li><a href="/details-blog-6656322454290ac7548c1a23">Attention aux annonces de logements meublés en ligne</a></li>
                <li><a href="/details-blog-6653d29e54290ac754727968">Exploring the Rich Tapestry of African Tourism and Culture</a></li>
                <li><a href="/details-blog-652b3bbcbdcd1865de67bea3">Chutes dEkom Nkam : Une Expérience Majestueuse de Cascade</a></li>
                <li><a href="/details-blog-64f233433bf350ba7dc8cdb2">Bouba Njida National Park: A Wildlife Haven</a></li> 
                <li><a href="/details-blog-64e08e87019fddc61090f7a9">Chutes de la Lobé : Quand la Cascade Rencontre la Mer</a></li>
                <li><a href="/details-blog-64e08e4e019fddc61090e210">Chutes de la Lobé : Quand la Cascade Rencontre la Mer</a></li>
                <li><a href="/details-blog-64db24e6019fddc61069fd0c">Découvrir le Patrimoine Maritime au Musée Maritime de Douala</a></li>
                <li><a href="/details-blog-64db23e7019fddc61069ed66">Explorer le Paradis de la Biodiversité du Parc national de Campo Ma'an</a></li> 
                <li><a href="/details-blog-64db232c019fddc61069e0aa">Révéler la Splendeur Royale au Musée du Palais des Rois Bamoun</a></li>
                <li><a href="/details-blog-64d77a5f019fddc610527abc">Découvrez les Merveilles du Jardin Zoologique de Garoua</a></li>
                <li><a href="/details-blog-64d64426019fddc6104844c3">Découvrez la Beauté Sereine du Parc national de la Bénoué</a></li>
                <li><a href="/details-blog-645d3737a8aa448be78391bb">Médecine du Voyage: Consultez avant de partir!</a></li> 
            </ul>  
        </div>
      );
    };
    
    export default Sitemap;